"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimePickerField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var DateTimePicker_1 = require("../../../Input/DateTimePicker");
var DateTimePickerField = function (_a) {
    var _b, _c, _d;
    var _e = _a.value, value = _e === void 0 ? null : _e, onChange = _a.onChange, error = _a.error, _f = _a.placeholder, placeholder = _f === void 0 ? '' : _f, titleProps = _a.titleProps, title = _a.title, descriptionProps = _a.descriptionProps, description = _a.description, textFieldProps = _a.textFieldProps, props = __rest(_a, ["value", "onChange", "error", "placeholder", "titleProps", "title", "descriptionProps", "description", "textFieldProps"]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "subtitle1", color: "text.secondary" }, titleProps, { children: (_b = titleProps === null || titleProps === void 0 ? void 0 : titleProps.children) !== null && _b !== void 0 ? _b : title })), !!((_c = descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.children) !== null && _c !== void 0 ? _c : description) && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", color: "text.secondary" }, descriptionProps, { children: (_d = descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.children) !== null && _d !== void 0 ? _d : description }))), (0, jsx_runtime_1.jsx)(DateTimePicker_1.DateTimePickerInput, __assign({ value: value, placeholder: placeholder, error: error, onChange: onChange, textFieldProps: __assign({ sx: __assign({ '.MuiOutlinedInput-input': {
                            py: 3,
                        }, '&& .MuiOutlinedInput-notchedOutline': {
                            borderColor: error ? 'error.main' : undefined,
                        }, '&& .MuiInputLabel-root, && .MuiFormHelperText-root': {
                            color: error ? 'error.main' : 'grey.600',
                        } }, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx), inputProps: __assign({ value: value ? value.format('YYYY/MM/DD HH:mm') : '' }, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.inputProps) }, textFieldProps) }, props))] }));
};
exports.DateTimePickerField = DateTimePickerField;
